import React from 'react';
import { UserRound, ShieldCheck, BellRing, Lock, ScrollText, Receipt } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { HostActionRow } from '../../components/HostSettingsCard';
import { HostSettingsLayout } from '../../components/HostSettingsLayout';

export default function VenueAccountSettingsPage() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const items = [
    {
      label: 'Personal Information',
      icon: <UserRound size={22} color="#000" strokeWidth={1.6} />,
      action: () => navigate('/venue/account-settings/personal'),
      testId: 'venue-account-settings-personal-button',
    },
    {
      label: 'Login & Security',
      icon: <ShieldCheck size={22} color="#000" strokeWidth={1.6} />,
      action: () => navigate('/venue/account-settings/security'),
      testId: 'venue-account-settings-security-button',
    },
    {
      label: 'Privacy',
      icon: <Lock size={22} color="#000" strokeWidth={1.6} />,
      action: () => navigate('/venue/account-settings/privacy'),
      testId: 'venue-account-settings-privacy-button',
    },
    {
      label: 'Notifications & History',
      icon: <BellRing size={22} color="#000" strokeWidth={1.6} />,
      action: () => navigate('/venue/account-settings/notifications'),
      testId: 'venue-account-settings-notifications-button',
    },
    {
      label: 'Agreements',
      icon: <ScrollText size={22} color="#000" strokeWidth={1.6} />,
      action: () => navigate('/venue/account-settings/agreements'),
      testId: 'venue-account-settings-agreements-button',
    },
    {
      label: 'Invoices',
      icon: <Receipt size={22} color="#000" strokeWidth={1.6} />,
      action: () => navigate('/venue/account-settings/invoices'),
      testId: 'venue-account-settings-invoices-button',
    },
  ];

  return (
    <HostSettingsLayout title="Account Settings" dataTestId="venue-account-settings-page">
      {items.map((item) => (
        <HostActionRow
          key={item.label}
          label={item.label}
          icon={item.icon}
          onClick={item.action}
          dataTestId={item.testId}
        />
      ))}
      <p
        data-testid="venue-account-settings-account-id"
        style={{
          marginTop: 18,
          textAlign: 'center',
          fontFamily: "'Inria Serif', serif",
          fontSize: 16,
          color: 'var(--text-3)',
        }}
      >
        Account ID: {user.customer_id || '—'}
      </p>
    </HostSettingsLayout>
  );
}
